"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadingReducers = void 0;
var setLoadingStart = function (state) {
    state.loading = true;
    state.result = undefined;
    state.error = undefined;
};
var setLoadingSuccess = function (state) {
    state.loading = false;
    state.result = true;
    state.error = undefined;
};
var setLoadingError = function (state, action) {
    state.loading = false;
    state.result = false;
    state.error = action.payload;
};
exports.loadingReducers = {
    setLoadingStart: setLoadingStart,
    setLoadingSuccess: setLoadingSuccess,
    setLoadingError: setLoadingError,
};
//# sourceMappingURL=loadingReducers.js.map